export function getApprovalStatus(data) {
  return data.path.includes('demandes_partenaires') && data.status_code === 0; // 0 = 'Non signé';
}

export function getFileNameFromPath(filePath) {
  if (!filePath) {
    console.warn('Error : missing file path in getFileNameFromPath');
    return 'Fichier';
  }
  const normalizedPath = filePath.replace(/\\\\/g, '\\');
  const segments = normalizedPath.split('\\');
  return segments[segments.length - 1];
}

export function getExtensionFromFileType(type) {
  if (typeof type === 'string' && type.includes('/')) {
    return type.split('/').pop() ?? '';
  }
}

export function getSearchData(targetType, isPartner) {
  let searchArg = {};
  switch (targetType) {
    case 'resource':
      searchArg = { resource: true }; // Documents of a resource
      break;
    case 'company':
      searchArg = { company: true }; // Documents of a company
      break;
    case 'client':
    case 'multi_client':
      searchArg = { client: true }; // Documents of a client
      break;
    case 'site':
      console.error('Document page is not used for sites');
      break;
    default:
      console.error('targetType is missing');
      break;
  }

  if (isPartner) {
    searchArg = { ...searchArg, partnerDemand: true };
  }

  return searchArg;
}
